import { Dispatch, ReactNode, SetStateAction } from "react";
import { Modal } from "./Modal";
import { PrimaryButton } from "./PrimaryButton";
import { SecondaryButton } from "./SecondaryButton";

export interface IConfirmationModalProps {
  isVisible: boolean;
  setIsVisible:
    | Dispatch<SetStateAction<boolean>>
    | ((condition: boolean) => void);
  onHideBeforeVisibleSetToFalse?: () => void;
  primaryButtonLabel: string;
  primaryButtonOnClick: () => void;
  secondaryButtonLabel?: string;
  secondaryButtonOnClick?: () => void;
  headerText: string | ReactNode;
  bodyText: string;
  isIcon?: boolean;
  icon?: string;
  className?: string;
  bodyContent?: ReactNode;
  bodyTextClassName?: string;
  bodyClassName?: string;
  isActionsDisabled?: boolean;
  isClosable?: boolean;
  primaryButtonIcon?: string;
  isDismissable?: boolean;
}

const ConfirmationModal = ({
  isVisible,
  setIsVisible,
  onHideBeforeVisibleSetToFalse,
  primaryButtonLabel,
  primaryButtonOnClick,
  secondaryButtonLabel,
  secondaryButtonOnClick,
  headerText,
  bodyText,
  isIcon = false,
  icon = "pi pi-exclamation-triangle",
  className,
  bodyContent,
  bodyTextClassName,
  bodyClassName,
  isActionsDisabled = false,
  isClosable = true,
  primaryButtonIcon = "",
  isDismissable = true,
}: IConfirmationModalProps) => {
  const footer = () => {
    return (
      <div className="flex justify-content-end align-items-center">
        {secondaryButtonOnClick && (
          <SecondaryButton
            className="uppercase"
            label={secondaryButtonLabel}
            onClick={secondaryButtonOnClick}
            isDisabled={isActionsDisabled}
          />
        )}
        <PrimaryButton
          className="ml-2 mr-0 uppercase"
          label={primaryButtonLabel}
          onClick={primaryButtonOnClick}
          disabled={isActionsDisabled}
          icon={primaryButtonIcon}
        />
      </div>
    );
  };

  return (
    <Modal
      isClosable={isClosable}
      visible={isVisible}
      setVisible={setIsVisible}
      onHideBeforeVisibleSetToFalse={onHideBeforeVisibleSetToFalse}
      headerText={headerText}
      bodyText={bodyText}
      icon={isIcon ? icon : ""}
      footer={footer}
      data-testid="confirmation modal"
      bodyContent={bodyContent && !bodyText ? bodyContent : <></>}
      className={className}
      bodyTextClassName={bodyTextClassName}
      bodyClassName={bodyClassName}
      isDismissable={isDismissable}
    />
  );
};

export default ConfirmationModal;
